module.exports = __webpack_public_path__ + "static/media/report_summary.b3064819.svg";